module.exports = __webpack_public_path__ + "img/wotive_blog.b2bac676.webp";